function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { useCallback } from 'react';
import { Button, Checkbox, FormControlLabel, TextField } from '@mui/material';
import { COLORS, SIZES, Typography } from '@fupa/fupa-uikit';
import styled from 'styled-components';
import { Action, DataEntry, Label } from 'app/components/match/liveResult/CommonRowStyles';
import { LoadingButton } from '@mui/lab';
import { Controller, useForm } from 'react-hook-form';
import { isNumber } from 'app/helpers/ValidationRules';
import { useStoreSofttickerFormDataInSessionStorage } from 'app/hooks/useStoreSofttickerFormDataInSessionStorage';
const FormContainer = styled.form.withConfig({
  componentId: "sc-1imksj6-0"
})(["display:grid;grid-template-columns:repeat(2,1fr) repeat(2,", ") repeat(2,1fr);gap:", ";margin:auto;"], SIZES['42'], SIZES['16']);
const GridElement = styled.div.withConfig({
  componentId: "sc-1imksj6-1"
})(["grid-column:span 2;display:grid;align-content:center;height:", ";", ""], SIZES['42'], props => props.shrink && "\n    @media (max-width: 400px) {\n      grid-column: span 1;\n    }\n  ");
const ErrorContainer = styled.div.withConfig({
  componentId: "sc-1imksj6-2"
})(["display:grid;grid-column:span 6;height:", ";overflow-y:scroll;"], SIZES['48']);
const ErrorTypography = styled(Typography).withConfig({
  componentId: "sc-1imksj6-3"
})(["&&&{color:", ";}"], COLORS.red);
const CustomNumberTextField = styled(TextField).withConfig({
  componentId: "sc-1imksj6-4"
})({
  '& .MuiInputBase-input': {
    paddingLeft: '8px',
    paddingRight: '8px',
    textAlign: 'center',
    '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0
    },
    '&[type=number]': {
      '-moz-appearance': 'textfield'
    }
  },
  '& .MuiOutlinedInput-root': {
    maxWidth: 42,
    '&:hover fieldset': {
      borderColor: COLORS.fupaSecondary
    },
    '&.Mui-focused fieldset': {
      borderColor: COLORS.fupaSecondary
    }
  }
});
export default function UpdateResultForm(_ref) {
  var _match$live, _errors$homeGoals, _errors$awayGoals, _errors$minute;
  let {
    match,
    data,
    onClose,
    onSubmit,
    submissionError,
    loading
  } = _ref;
  const {
    register,
    handleSubmit,
    formState: {
      errors
    },
    setError,
    getValues,
    setValue,
    control
  } = useForm({
    defaultValues: {
      minute: data === null || data === void 0 ? void 0 : data.currentMatchMinute,
      final: false
    },
    mode: 'onTouched',
    reValidateMode: 'onChange'
  });
  const initializeResultForm = useCallback(data => {
    Object.keys(data).forEach(key => {
      setValue(key, data[key]);
    });
  }, [setValue]);
  useStoreSofttickerFormDataInSessionStorage('liveResultFormData', getValues, initializeResultForm);
  const onValidationSuccess = async data => {
    var _data$final;
    const submitData = {
      ...data,
      final: (_data$final = data.final) !== null && _data$final !== void 0 ? _data$final : false
    };
    onSubmit(submitData, setError);
  };
  return /*#__PURE__*/React.createElement(FormContainer, {
    "data-sentry-element": "FormContainer",
    "data-sentry-component": "UpdateResultForm",
    "data-sentry-source-file": "UpdateResultForm.tsx"
  }, /*#__PURE__*/React.createElement(GridElement, {
    "data-sentry-element": "GridElement",
    "data-sentry-source-file": "UpdateResultForm.tsx"
  }, /*#__PURE__*/React.createElement(Label, {
    variant: "body1",
    "data-sentry-element": "Label",
    "data-sentry-source-file": "UpdateResultForm.tsx"
  }, "Spielstand")), /*#__PURE__*/React.createElement(GridElement, {
    "data-sentry-element": "GridElement",
    "data-sentry-source-file": "UpdateResultForm.tsx"
  }, /*#__PURE__*/React.createElement(DataEntry, {
    "data-sentry-element": "DataEntry",
    "data-sentry-source-file": "UpdateResultForm.tsx"
  }, /*#__PURE__*/React.createElement(CustomNumberTextField, _extends({
    error: !!errors.homeGoals,
    type: "number",
    variant: "outlined",
    size: "small",
    inputProps: {
      inputMode: 'numeric'
    }
  }, register('homeGoals', {
    required: 'Gib die Anzahl der Heimtore an.',
    validate: {
      isNumber
    },
    max: {
      value: 99,
      message: 'Die Anzahl der Heimtore darf maximal 99 sein.'
    },
    min: {
      value: 0,
      message: 'Die Anzahl der Heimtore muss mindestens 0 sein.'
    }
  }), {
    "data-sentry-element": "CustomNumberTextField",
    "data-sentry-source-file": "UpdateResultForm.tsx"
  })), /*#__PURE__*/React.createElement(Label, {
    variant: "body1",
    "data-sentry-element": "Label",
    "data-sentry-source-file": "UpdateResultForm.tsx"
  }, ":"), /*#__PURE__*/React.createElement(CustomNumberTextField, _extends({
    error: !!errors.awayGoals,
    type: "number",
    variant: "outlined",
    size: "small",
    inputProps: {
      inputMode: 'numeric'
    }
  }, register('awayGoals', {
    required: 'Gib die Anzahl der Gasttore an.',
    validate: {
      isNumber
    },
    max: {
      value: 99,
      message: 'Die Anzahl der Gasttore darf maximal 99 sein.'
    },
    min: {
      value: 0,
      message: 'Die Anzahl der Gasttore muss mindestens 0 sein.'
    }
  }), {
    "data-sentry-element": "CustomNumberTextField",
    "data-sentry-source-file": "UpdateResultForm.tsx"
  })))), /*#__PURE__*/React.createElement(GridElement, {
    "data-sentry-element": "GridElement",
    "data-sentry-source-file": "UpdateResultForm.tsx"
  }), /*#__PURE__*/React.createElement(GridElement, {
    "data-sentry-element": "GridElement",
    "data-sentry-source-file": "UpdateResultForm.tsx"
  }, /*#__PURE__*/React.createElement(Label, {
    variant: "body1",
    "data-sentry-element": "Label",
    "data-sentry-source-file": "UpdateResultForm.tsx"
  }, "Spielminute")), /*#__PURE__*/React.createElement(GridElement, {
    shrink: true,
    "data-sentry-element": "GridElement",
    "data-sentry-source-file": "UpdateResultForm.tsx"
  }, /*#__PURE__*/React.createElement(DataEntry, {
    "data-sentry-element": "DataEntry",
    "data-sentry-source-file": "UpdateResultForm.tsx"
  }, /*#__PURE__*/React.createElement(CustomNumberTextField, _extends({
    error: !!errors.minute,
    type: "number",
    variant: "outlined",
    size: "small",
    inputProps: {
      inputMode: 'numeric'
    }
  }, register('minute', {
    required: 'Gib die aktuelle Spielminute an.',
    validate: {
      isNumber
    },
    max: {
      value: 199,
      message: 'Es darf maximal Minute 199 angegeben werden.'
    },
    min: match !== null && match !== void 0 && (_match$live = match.live) !== null && _match$live !== void 0 && _match$live.minute && !(data !== null && data !== void 0 && data.canStoreFinalResult) ? {
      value: match.live.minute,
      message: 'Es wurde bereits ein späterer Zwischenstand gemeldet.'
    } : {
      value: 0,
      message: 'Es muss mindestens Minute 0 angegeben sein.'
    }
  }), {
    "data-sentry-element": "CustomNumberTextField",
    "data-sentry-source-file": "UpdateResultForm.tsx"
  })))), /*#__PURE__*/React.createElement(GridElement, {
    "data-sentry-element": "GridElement",
    "data-sentry-source-file": "UpdateResultForm.tsx"
  }, /*#__PURE__*/React.createElement(FormControlLabel, {
    disabled: !(data !== null && data !== void 0 && data.canStoreFinalResult),
    control: /*#__PURE__*/React.createElement(Controller, {
      control: control,
      name: 'final',
      render: _ref2 => {
        let {
          field: {
            value,
            ref,
            ...field
          }
        } = _ref2;
        return /*#__PURE__*/React.createElement(Checkbox, _extends({
          inputRef: ref,
          checked: value
        }, field));
      }
    }),
    label: "Endstand?",
    labelPlacement: "start",
    "data-sentry-element": "FormControlLabel",
    "data-sentry-source-file": "UpdateResultForm.tsx"
  })), /*#__PURE__*/React.createElement(ErrorContainer, {
    "data-sentry-element": "ErrorContainer",
    "data-sentry-source-file": "UpdateResultForm.tsx"
  }, ((_errors$homeGoals = errors.homeGoals) === null || _errors$homeGoals === void 0 ? void 0 : _errors$homeGoals.message) && /*#__PURE__*/React.createElement(ErrorTypography, {
    variant: "caption1"
  }, errors.homeGoals.message), ((_errors$awayGoals = errors.awayGoals) === null || _errors$awayGoals === void 0 ? void 0 : _errors$awayGoals.message) && /*#__PURE__*/React.createElement(ErrorTypography, {
    variant: "caption1"
  }, errors.awayGoals.message), ((_errors$minute = errors.minute) === null || _errors$minute === void 0 ? void 0 : _errors$minute.message) && /*#__PURE__*/React.createElement(ErrorTypography, {
    variant: "caption1"
  }, errors.minute.message), submissionError && /*#__PURE__*/React.createElement(ErrorTypography, {
    variant: "caption1"
  }, submissionError)), /*#__PURE__*/React.createElement(Action, {
    span: 3,
    "data-sentry-element": "Action",
    "data-sentry-source-file": "UpdateResultForm.tsx"
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "text",
    sx: {
      color: COLORS.darkestGrey
    },
    onClick: onClose,
    "data-sentry-element": "Button",
    "data-sentry-source-file": "UpdateResultForm.tsx"
  }, "Abbrechen")), /*#__PURE__*/React.createElement(Action, {
    span: 3,
    justify: "end",
    "data-sentry-element": "Action",
    "data-sentry-source-file": "UpdateResultForm.tsx"
  }, /*#__PURE__*/React.createElement(LoadingButton, {
    variant: "contained",
    color: "secondary",
    onClick: handleSubmit(onValidationSuccess),
    loading: loading,
    "data-sentry-element": "LoadingButton",
    "data-sentry-source-file": "UpdateResultForm.tsx"
  }, "Speichern")));
}